export default __webpack_public_path__ + "static/etihad-logo-8fefe0ac40caf90e419255c9b628eb84.png";